export default async function runBatch(db, callback) {
	const batch = db.batch();

	const result = await callback(batch);

	await batch.commit();

	return result;
}
